export const srcLinks = [
  { name: "Community", src: "https://discord.com/invite/pixelchain" },
  {
    name: "Learn more",
    src: "https://medium.com/nft-studios/pixelchain-256-alpha-launches-on-october-14th-2b9d37278960",
  },
  { name: "View collection", src: "https://opensea.io/collection/pixelchain-256" },
];
